import {request, HTTPError} from "../api";
import {type GridDocument} from "./document";
import {createGridRenderPlan} from "./render-plan";

export async function exportGrid(document: GridDocument, signal: AbortSignal): Promise<{blob: Blob; filename: string}> {
  createGridRenderPlan(document);
  let result;
  try {
    result = await request("/api/v3/grids/render", {method: "POST", credentials: "include", responseType: "download", signal, body: JSON.stringify({document, output: "download"})});
  } catch (error) {
    if (error instanceof HTTPError && typeof error.data?.message === "string") throw new Error(`${error.data.message}${error.data.instanceId ? ` (${error.data.instanceId})` : ""}`);
    throw error;
  }
  if (!result?.filename || !(result.blob instanceof Blob) || !["image/png", "application/zip"].includes(result.blob.type)) throw new Error("Invalid Grid export response");
  return result;
}
